
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BankTransferRecipientPayloadWithSca": [
      "BankTransferRecipientPayload",
      "StrongAuthenticationRequired"
    ],
    "BulkBankTransferWithSca": [
      "BulkBankTransfer",
      "StrongAuthenticationRequired"
    ],
    "CardDigitizationDataPayloadWithSca": [
      "CardDigitizationDataPayload",
      "StrongAuthenticationRequired"
    ],
    "CreateInternationalTransferQuoteResponse": [
      "CreateInternationalTransferQuoteResponseError",
      "CreateInternationalTransferQuoteResponseSuccess"
    ],
    "CreateInternationalTransferRecipientResponse": [
      "InternationalTransferProviderErrorResponse",
      "InternationalTransferRecipient"
    ],
    "CreateInternationalTransferResponse": [
      "InternationalTransferPayout",
      "InternationalTransferProviderErrorResponse"
    ],
    "CreditCardInterface": [
      "CreditCard",
      "CreditCardPendingOrder"
    ],
    "CreditCardPayloadWithSca": [
      "CreditCardPayload",
      "StrongAuthenticationRequired"
    ],
    "EnrollDeviceOutput": [
      "Device",
      "StrongAuthenticationRequired"
    ],
    "EnrollMdaDeviceOutput": [
      "Device",
      "StrongAuthenticationRequired"
    ],
    "FeatureFilter": [
      "RoleFilter",
      "UserFilter"
    ],
    "InitiateResetMdaOutput": [
      "MdaResetStatus",
      "StrongAuthenticationRequired"
    ],
    "PaymentCardInterface": [
      "PaymentCard",
      "PaymentCardPendingOrder"
    ],
    "PaymentCardNumbersPayloadWithSca": [
      "PaymentCardNumbers",
      "StrongAuthenticationRequired"
    ],
    "PhysicalPaymentCardPinPayloadWithSca": [
      "PhysicalPaymentCardPin",
      "StrongAuthenticationRequired"
    ],
    "TeamMembersRequest": [
      "BankTransferRequest",
      "ExpenseClaimRequest",
      "PhysicalPaymentCardOrderRequest",
      "VirtualBudgetCardOrderRequest",
      "VirtualPaymentCardOrderRequest"
    ],
    "UnderReviewWidget": [
      "KycUnderReviewWidget",
      "OnboardingTimelineWidget"
    ]
  }
};
      export default result;
    